<template>
  <v-list-item v-if="canShow(item)" :href="href" :to="item.to" exact class="px-2 py-1">
    <template #default="{isActive}">
    <v-sheet rounded="xl" class="d-flex align-center pa-2 w-100" :class="(isActive) ? 'active-list-item' : 'bg-transparent'">
      <!-- icon -->
      <v-avatar color="white" size="42" style="border-radius: 16px;" class="mr-3">
        <template v-if="item.icon">
          <component v-if="item.icon.includes('Ph')" :is="item.icon" size="24" />
          <v-icon v-else :icon="item.icon" />
        </template>
      </v-avatar>
      <div class="sm-semi-bold text-primary text-truncate">
        {{ item.title }}
      </div>
    </v-sheet>
    </template>
  </v-list-item>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions";
import { PhFireExtinguisher, PhLayout, PhAddressBook, PhCalendarCheck, PhFolders, PhTreeView, PhClipboard, PhListChecks, PhUserSwitch, PhSlidersHorizontal } from "@phosphor-icons/vue";

export default {
  name: "BaseItem",
  components: { PhFireExtinguisher, PhLayout, PhAddressBook, PhCalendarCheck, PhFolders, PhTreeView, PhClipboard, PhListChecks, PhUserSwitch, PhSlidersHorizontal },
  setup() {
    const { can } = useAbility();
    return {
      can
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    canShow(item) {
      //CHECK IF CLIENT BOUGHT THE MODULE
      if(item.modules) {
        let disabled_modules_counter = 0;
        for (let i = 0; i < item.modules.length; i++) {
          let perluta_module = this.$store.getters.getPerlutaModules.find((record) => record.name === item.modules[i]);
          if(perluta_module && !perluta_module.status) {
            disabled_modules_counter++;
          }
        }
        if(disabled_modules_counter === item.modules.length) {
          return false;
        }
      }
      //OTHER CHECKS
      if(item.gate.subject === 'home') {
        return true;
      }
      else if(item.gate.subject === 'search') {
        let search_models = Object.keys(helpFunctions.can_search);
        for (let i = 0; i < search_models.length; i++) {
          if(this.can("show", this.$createEntity(search_models[i], { id: 0 }))) {
            return true;
          }
        }
      }
      else if(typeof(item.gate.subject) === 'string') {
        return this.can("show", this.$createEntity(item.gate.subject.toLowerCase(), { id: 0 }));
      }
      else {
        return false;
      }
    },
  },
  computed: {
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },
};
</script>

<style scoped>
:deep(.v-list-item__overlay) {
  opacity: 0 !important;
}
.active-list-item {
  background-color: rgba(var(--v-theme-primary), 0.3) !important;
}
</style>